<template>
	<section>
		<div class="col-sm-12 ">
			<center>
				<div
				class=" login-card col-sm-6 shadow p-3 mb-5 bg-body rounded position-absolute top-50 start-50 translate-middle ">
				<form @submit.prevent="onSubmit()">
					<div class=" p-5  text-center">
						<router-link :to="{ name: 'home' }" class="navbar-brand"><img src="/design/sigofood-images/logo.png"></router-link>
						<p class="fw-semibold login_details login_texts">CUSTOMER LOGIN</p>
						<div class="text-start">
							<div class="text-box">
								<p class="fw-semibold login_details login_texts">Email address/ Mobile Number</p>
								<input class="form-control login_subtexts" type="text" placeholder="Enter your Email or Mobile" v-model="username"  @keypress="noSpaces"  v-bind:class="{ 'is-invalid': Boolean(errors.username && errors.username.length) }">
                        <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
							</div>

							<div class="text-box" style="position: relative;">
								<p class="fw-semibold login_details login_texts">Password</p>
								<input class="form-control login_subtexts" type="text" placeholder="Enter your Password" v-model="password" v-if="show_password"  @keypress="noSpaces" v-bind:class="{ 'is-invalid': Boolean(errors.password && errors.password.length) }">
                        <input class="form-control login_subtexts" type="password" placeholder="Enter your Password" v-model="password" v-else  @keypress="noSpaces" v-bind:class="{ 'is-invalid': Boolean(errors.password && errors.password.length) }">
								<!-- <img class="eye" src="/design/sigofood-images/eye.png"> -->
                        <i class="material-icons eye" v-if="show_password" @click="togglePassword()">visibility</i>
                        <i class="material-icons eye" v-else @click="togglePassword()">visibility_off</i>
                        <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
								<a href="forgot-password.html">
									<p class="text-end forgot-password" >Forgot Password?</p>
								</a>

							</div>

							<div class="d-grid mx-auto">
								<button type="submit" class="btn place-order">Sign In</button>
								<span class="text-center no-account">Don’t have an account?
                           <router-link :to="{ name: 'register' }"><span class="sign-in">Sign Up</span></router-link>
								</span>

							</div>
						</div>
					</div>
				</form>
			</div>
		</center>

	</div>

</section>

</template>

<script>
export default {
	
	data() {
      return {
         username: "",
         password: "",   
         errors: {}, 
         token: ""  ,
         user: {},
         fcm: "",
         uid: "",
         show_password: false,
         style: null,
      };      
   },

   created() {
      this.style = document.createElement('link')
      this.style.setAttribute('rel', 'stylesheet')
      this.style.setAttribute('href', '/design/signin.css')
      document.head.appendChild(this.style)
   },   

   beforeDestroy() {
      document.head.removeChild(this.style);
   },

   mounted() {
   },
  
   methods: {

      noSpaces(event) {
         let keyCode = event.keyCode;
         if ((keyCode == 32)) {
            event.preventDefault();            
         } else {
            return;
         }
      },

      togglePassword() {
         if(this.show_password == false) {
               this.show_password = true;
         } else {
               this.show_password = false;
         }
      },

      onSubmit() {
         this.errors = {
            username: [],
            password: [],
         };

         let is_valid = true;
            
         if(this.username == '') {
            this.errors.username[0] = 'Please enter username';
            is_valid = false;
         }        

         if(this.password == '') {
            this.errors.password[0] = 'Please enter password';
            is_valid = false;
         } 

         if (is_valid == true) {
            //console.log(data);
            const config = {
               headers: {
                 "Content-Type": "multipart/form-data",
                 "Accept": "application/json",
               },
            };

            if(localStorage.getItem('sigofood_fcm')) {
               this.fcm = localStorage.getItem('sigofood_fcm');
            }
            if(localStorage.getItem('sigofood_uid')) {
               this.uid = localStorage.getItem('sigofood_uid');
            }

            this.errors = {};

            let formData = new FormData();
         	formData.append("username", this.username);
         	formData.append("password", this.password);
            formData.append("fcm", this.fcm);         
            formData.append("uid", this.uid);        

            this.$axios
            .post("login", formData, config)
            .then((response) => {
               console.log(response);
               //this.user = response.data.data;
               if(response.status == 200) {
                  
                  var responseData = response.data.data;
                  if (responseData.token) {
                     console.log(responseData);
                     localStorage.setItem('sigofood_user', JSON.stringify(responseData));                  
                     this.token = responseData.token;
                     //this.$router.push({ name: "dashboard" });
                     this.$router.go(-1);
                     this.$swal("", "You have logged in successfully", "success");        
                  
                  } else {
                     this.$swal("", "Failed to fetch token, please try again", "error");
                  }
               }
            })
            .catch((error) => {
               console.log(error);
               console.log(error.response);
               if (error.response) {
                  if (error.response.status == 422) {
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     }
                     this.$swal("", error.response.statusText, "error");
                  } else if (error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");
                  } else if (error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            });
            //.finally(() => (this.loading = false));
         }
      },
   },
}
</script>
